<div class="container">
  <div class="div-img">
    <img src="assets/images/builtup.svg" />
  </div>
  <div class="login">
    <h1>Bem-vindo!</h1>
    <form class="login-inputs">
      <app-input
        type="email"
        label="E-mail"
        [placeholder]="'Digite'"
        class="input-login input-email"
        name="email"
        [labelColor]="updateCorLabel()"
        [(ngModel)]="login.email"
        ngDefaultControls
      ></app-input>
      <app-input
        type="password"
        label="Senha"
        class="input input-login"
        [placeholder]="'Digite'"
        name="senha"
        [labelColor]="updateCorLabel()"
        [(ngModel)]="login.senha"
        ngDefaultControl
      ></app-input>
      <app-botao
        (click)="loginSubmit()"
        class="input-login button-desktop"
        text="Entrar"
        [disabled]="validarForm() ? false : true"
      ></app-botao>
      <label class="forgot-password" (click)="goTo('esqueci-a-senha')"
        >Esqueceu a senha?</label
      >
      <app-botao
        (click)="loginSubmit()"
        class="input-login button-mobile"
        bgColor="#2c8ac0"
        text="Entrar"
        [disabled]="validarForm() ? false : true"
      ></app-botao>
    </form>
  </div>
</div>

<app-loader *ngIf="loader" />
